<template lang="pug">
  v-dialog(:value="open", width="363", persistent).failed-attempt-modal
    v-card(style="border-radius: 5px;")
      v-card-text
        v-layout(align-center justify-center column fill-height)
          v-flex(style="margin-top: 1.5em;height: 150px;")
            v-img
              img(:src="alertIcon" :style="{height: '150px', width: '150px'}")
          v-flex(style="margin:1em;text-align: center;")
            span.omnesMedium(style="font-size: 18px;color: #0855C4;") {{ title }}
          v-flex.failed-attempt-message(style="text-align: center;width: 22em;")
            span(style="font-size: 16px;line-height: initial;color: #535D66;") {{ body }}
          v-flex.failed-attempt-buttons(style="margin-top: 2.5em;margin-bottom: 1em;")
            v-layout(row justify-center)
              v-btn.failed-attempt-btn-primary(@click="$emit('retry')")
                span.omnesSemibold Volver a intentarlo
              v-btn.failed-attempt-btn-secondary(@click="$emit('secondary-action')")
                span.omnesSemibold {{ secondaryButtonText }}
</template>

<script>
/**
 * @component FailedAttemptModal
 * @description Modal que se muestra en intentos fallidos de login (1er y 2do intento).
 * Muestra un mensaje genérico anti-enumeración con dos acciones:
 * volver a intentar o ir a recuperación/registro.
 * @example
 * FailedAttemptModal(
 *   :open="failedAttempt.showModal"
 *   :title="failedAttempt.title"
 *   :body="failedAttempt.body"
 *   :secondaryButtonText="failedAttempt.secondaryButtonText"
 *   @retry="retryLogin"
 *   @secondary-action="handleFailedAttemptSecondaryAction"
 * )
 */
export default {
  name: 'FailedAttemptModal',
  props: {
    /** Controla la visibilidad del modal */
    open: {
      type: Boolean,
      required: true
    },
    /** Título del modal */
    title: {
      type: String,
      default: ''
    },
    /** Cuerpo / mensaje del modal */
    body: {
      type: String,
      default: ''
    },
    /** Texto del botón secundario (ej: "Olvidé mi contraseña", "Registrarme") */
    secondaryButtonText: {
      type: String,
      default: 'Registrarme'
    }
  },
  computed: {
    alertIcon () {
      return require('@/assets/characters/alerta.svg')
    }
  }
}
</script>

<style scoped>
.failed-attempt-modal .failed-attempt-message {
  text-align: center;
  width: 22em;
}
.failed-attempt-btn-primary {
  background: #FFFFFF !important;
  border: 1px solid #EA0D90 !important;
  border-radius: 4px !important;
  width: 152px !important;
  height: 45px !important;
  margin-right: 10px !important;
  box-shadow: none !important;
}
.failed-attempt-btn-primary span {
  text-transform: initial !important;
  font-size: 15px !important;
  color: #EA0D90 !important;
}
.failed-attempt-btn-secondary {
  background: #EA0D90 !important;
  border-radius: 4px !important;
  width: 152px !important;
  height: 45px !important;
  box-shadow: none !important;
}
.failed-attempt-btn-secondary span {
  text-transform: initial !important;
  font-size: 15px !important;
  color: #FFFFFF !important;
}

@media only screen and (max-width: 600px) {
  .failed-attempt-modal >>> .v-dialog {
    max-width: 90% !important;
    width: 90% !important;
  }
  .failed-attempt-message {
    width: 100% !important;
    max-width: 100% !important;
    padding: 0 1em;
  }
  .failed-attempt-buttons {
    width: 100%;
    padding: 0 0.5em;
  }
  .failed-attempt-btn-primary,
  .failed-attempt-btn-secondary {
    width: 140px !important;
    height: 45px !important;
    margin-right: 8px !important;
  }
  .failed-attempt-btn-primary span,
  .failed-attempt-btn-secondary span {
    font-size: 15px !important;
  }
}

@media only screen and (max-width: 375px) {
  .failed-attempt-modal >>> .v-dialog {
    max-width: 95% !important;
    width: 95% !important;
  }
  .failed-attempt-message {
    padding: 0 0.5em;
  }
  .failed-attempt-message span {
    font-size: 14px !important;
  }
  .failed-attempt-buttons {
    margin-top: 1.5em !important;
    margin-bottom: 0.5em !important;
    padding: 0;
  }
  .failed-attempt-btn-primary,
  .failed-attempt-btn-secondary {
    width: 140px !important;
    height: 45px !important;
    margin-right: 6px !important;
  }
  .failed-attempt-btn-primary span,
  .failed-attempt-btn-secondary span {
    font-size: 15px !important;
  }
}

@media only screen and (max-width: 325px) {
  .failed-attempt-modal >>> .v-dialog {
    max-width: 95% !important;
    width: 95% !important;
  }
  .failed-attempt-message {
    padding: 0 0.5em;
  }
  .failed-attempt-message span {
    font-size: 13px !important;
    line-height: 1.5 !important;
  }
  .failed-attempt-buttons {
    margin-top: 1.5em !important;
    margin-bottom: 0.5em !important;
    padding: 0;
  }
  .failed-attempt-btn-primary,
  .failed-attempt-btn-secondary {
    width: 120px !important;
    height: 36px !important;
    margin-right: 6px !important;
  }
  .failed-attempt-btn-primary span,
  .failed-attempt-btn-secondary span {
    font-size: 12px !important;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/login/FailedAttemptModal.vue